import { useBranding } from '@/context/BrandingContext';

export default function Logo({ collapsed = false }) {
  const { branding } = useBranding();
  if (collapsed) return null;

  return (
    <div className="flex min-w-0 items-center gap-3">
      <img
        src={branding.sidebar_logo_url || branding.logo_url || '/fpccs-mark.svg'}
        alt={branding.company_name}
        className="h-12 w-12 shrink-0 rounded-xl object-contain bg-[var(--fpccs-surface-2)]"
      />

      <div className="min-w-0 leading-tight">
        <p className="text-base font-bold tracking-wide text-[var(--fpccs-text)] truncate">{branding.application_name}</p>
        <p className="text-sm text-[var(--fpccs-text-muted)] truncate">{branding.company_name}</p>
      </div>
    </div>
  );
}
